









































import { ProductionRecipe } from "@megarax/client/src/resources/plm";
import DefaultRevisionSheet from "@/components/DefaultRevisionSheet.vue";

import { createComponent } from "@vue/composition-api";
import ResourceItemReference from "@/components/resource/ResourceItemReference";
import IngredientsSheet from "../receptura/IngredientsSheet.vue";

export default createComponent({
  components: {
    DefaultRevisionSheet,
    ResourceItemReference,
    IngredientsSheet,
  },
  props: {
    value: {
      type: ProductionRecipe,
      required: true,
    },
  },
  setup(props, ctx) {
    return {};
  },
});
